<template>
	<BContainer>
		<BRow align-h="center">
			<BCol lg="8">
				<template v-if="step === 1">
					<BCard>
						<h3>Setup Credit Card</h3>
						<p>
							Please enter your credit card details below. We will use this card to charge you for your bookings.
						</p>
						<credit-card-form
							ref="creditCardForm"
							:country="user.country" />
						<BAlert variant="danger" :model-value="stripe_errors !== null"
							class="mt-2">
							{{ stripe_errors }}
						</BAlert>
						<hr class="border-light">
						<div class="d-flex justify-content-between mt-2">
							<div>
								<img src="/assets/img/powered-by-stripe.svg" style="height: 24px;" />
							</div>
							<div>
								<BButton variant="primary" :disabled="submitting"
									@click="submit">
									<BSpinner v-if="submitting" small
										class="mr-2"></BSpinner>
									Save Card
								</BButton>
							</div>
						</div>
					</BCard>
				</template>
				<template v-if="step === 2">
					<BCard class="px-4">
						<BRow align-v="center">
							<BCol>
								<h3>Your bookings have been converted to use Credit Card!</h3>
								<div>
									You can now return to the dashboard
								</div>
								<router-link class="btn btn-success mt-4 d-inline-flex align-items-center" to="/">
									<BIcon icon="arrow-left" class="mr-2"></BIcon>
									Return to Dashboard
								</router-link>
							</BCol>
							<BCol lg="3">
								<lottie-player src="/assets/animations/success.json"
									autoplay
									style="width: 100%; height:250px">
								</lottie-player>
							</BCol>
						</BRow>
					</BCard>
				</template>
			</BCol>
		</BRow>
	</BContainer>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import { mapGetters } from 'vuex';
	import CreditCardForm from './CreditCardForm.vue';

	export default {
		components: {
			CreditCardForm,
		},
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				step: 1,
				stripe_errors: null,
				submitting: false,
			};
		},
		computed: {
			...mapGetters({
				user: 'auth/user',
			})
		},
		methods: {
			async submit() {
				this.stripe_errors = null;
				this.submitting = true;

				const token = await this.$refs.creditCardForm.createToken().catch(error => {
					this.error = error;
				});

				await this.$axios.post('/api/account/update-card-and-convert-all-bookings', {
					token: token,
				}).then(() => {
					this.step = 2;
				}).catch((error) => {
					this.handleError(error);

					if (error.response.data.status === false) {
						this.stripe_errors = error.response.data.errors
					}
				});

				this.submitting = false;
			}
		}
	}
</script>
